import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SimpleToggle, Typography } from '@dev/ee-components';
import { TrackLinkGAToggleProps } from '@/components/CampaignCreator/SettingsAndTracking/SettingsAndTrackingInterface';
import { SwitchUTM } from '@/store/campaignCreator/actions';
import { ToggleWrapper } from '../../../../../../styled';

import { useCampaignScreensPathsChecker } from '../../../../../../hooks/useCampaignScreensPathsChecker';

export const TrackLinksGAToggle = ({ isChecked }: TrackLinkGAToggleProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();

    const changeToggleHandler = (): void => {
        dispatch(SwitchUTM());
    };

    return (
        <ToggleWrapper>
            <SimpleToggle
                id="link-click-toggle"
                value="tracklinkclicks"
                onChange={changeToggleHandler}
                checked={isChecked}
                disabled={isDetailsScreen}
            />
            <Typography variant="h3">{t('tracklinkinGA')}</Typography>
        </ToggleWrapper>
    );
};
